import script from "./SubscriptionUpdatedDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionUpdatedDialog.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionUpdatedDialog.vue?vue&type=style&index=0&id=0ebc5352&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ebc5352"]])

export default __exports__